import { ReactNode } from 'react';

/**
 * Renders above-the-fold intro content on tool pages to avoid "low value content" flags.
 * Use on every tool page: unique title + 2–4 sentences describing what the tool does and who it's for.
 */
interface ToolPageIntroProps {
  title: string;
  children: ReactNode;
}

export function ToolPageIntro({ title, children }: ToolPageIntroProps) {
  return (
    <div className="mb-6 sm:mb-8">
      <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-50 sm:text-3xl">
        {title}
      </h1>
      <div className="mt-2 max-w-3xl text-sm leading-relaxed text-slate-600 dark:text-slate-400 sm:text-base">
        {children}
      </div>
    </div>
  );
}
